import { defineComponent, getCurrentInstance } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  setup() {
    const globalProperties = getCurrentInstance()?.appContext.config.globalProperties;

    const route = useRoute();

    return () => (
      <>
        { globalProperties?.$errorMessage ? <mk-no-status isShowReTurnBar={true} description={globalProperties?.$errorMessage} /> : <router-view key={route.fullPath} /> }
      </>
    );
  }
});
